import { useState, useEffect } from 'react';

const useScreenOrientation = () => {
	const isLandscape = () => window.matchMedia('(orientation:landscape)').matches;

	const [orientation, setOrientation] = useState(isLandscape() ? 'landscape' : 'portrait');
	const onWindowResize = () => {
		clearTimeout(window.resizeLag);
		window.resizeLag = setTimeout(() => {
			delete window.resizeLag;
			setOrientation(isLandscape() ? 'landscape' : 'portrait');
		}, 10);
	};

	useEffect(() => {
		window.addEventListener('resize', onWindowResize);
		return () => window.removeEventListener('resize', onWindowResize);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return orientation;
};

export default useScreenOrientation;
